import React from 'react';
import { useGuest } from '../../context/GuestContext';

const GuestCTA = () => {
  const { openRequestModal } = useGuest();

  return (
    <>
      {/* Final CTA */}
      <section className="py-28 bg-[#2f2f2f] text-white">
        <div className="max-w-4xl mx-auto px-10 text-center">
          <div className="inline-flex items-center gap-2 border border-[#ff6600]/30 bg-[#ff6600]/10 text-[#ff6600] text-xs font-semibold tracking-widest uppercase px-4 py-1.5 rounded-full mb-8">
            <span className="w-1.5 h-1.5 rounded-full bg-[#ff6600]"></span>
            Ready to get started
          </div>
          <h2 className="text-5xl font-extrabold leading-tight mb-6">
            Start building{' '}
            <span className="italic text-[#ff6600]">trust</span>{' '}
            with your customers today
          </h2>
          <p className="text-[#919191] mb-10 text-base leading-relaxed">
            Submit a request below and our team will reach out within one business day. No commitment required — just a conversation about how My Risk Shield can work for your organization.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
            <button
              onClick={openRequestModal}
              className="bg-[#ff6600] text-white px-8 py-3 hover:bg-[#0077b5]/80 font-semibold transition-colors"
            >
              Send a request
            </button>
            <button
              onClick={() => window.open('https://outlook.office365.com/owa/calendar/ITPeopleNetworkRiskAssessmentSupport@itpeoplenetwork.com/bookings/', '_blank')}
              className="border border-[#919191]/50 text-white px-8 py-3  hover:bg-white/5 transition-colors"
            >
              Schedule a demo
            </button>
          </div>
          <p className="text-[#919191] text-sm">
            No credit card required&nbsp;&nbsp;·&nbsp;&nbsp;Response within 1 business day&nbsp;&nbsp;·&nbsp;&nbsp;Free trial available
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#272626] text-[#919191] py-6 border-t border-white/10">
        <div className="max-w-screen-2xl mx-auto px-10 flex flex-col sm:flex-row items-center justify-between gap-4">
          {/* <div className="flex items-center gap-2 text-white font-semibold text-sm">
            <img
              src={`${process.env.PUBLIC_URL}/logo-icon1.png`}
              alt="My Risk Shield logo"
              className="w-7 h-7 object-contain"
            />
            <div className="flex flex-col leading-none">
              <span>Risk Shield</span>
              <span className="font-semibold text-[9px] tracking-widest text-[#ff6600] mt-0.5">DETECT &amp; PROTECT</span>
            </div>
          </div> */}
          <div className="flex items-center gap-6 text-sm">
            <a href="#" className="hover:text-white transition-colors">Privacy policy</a>
            <a href="#" className="hover:text-white transition-colors">Terms of service</a>
            <a href="#" className="hover:text-white transition-colors">Security</a>
            <a href="#" className="hover:text-white transition-colors">Contact</a>
          </div>
          <p className="text-xs text-[#919191]">&copy; 2026 My Risk Shield. All rights reserved.</p>
        </div>
      </footer>
    </>
  );
};

export default GuestCTA;
